import React, { useState } from "react";
import axios from "axios";
import Head from "next/head";
import styles from "../../signature.module.css";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { FaFileUpload, FaKey } from "react-icons/fa";
import { BASE_URL_POST } from "../../../../constants/constants";
import Blog from "../../../../components/CalculatorBlogs/Blog";
import SignaturePopup from "../../../../components/SignaturePopup";
import PdfToolsLinks from "../../../../components/PdfToolsLinks";

const BlogData = [
  {
    id: 1,
    question: "What is Decrypt PDF Tool?",
    answer: (
      <div className="">
        <p className="">
          A Decrypt PDF Tool is a software that allows you to remove encryption
          from PDF documents. It enables users to access the content of
          encrypted PDF files by decrypting them using the correct password or
          decryption key.
        </p>
      </div>
    ),
  },
  {
    id: 2,
    question: "How to Use the Decrypt PDF Tool?",
    answer: (
      <div className="">
        <p className="">
          To use the Decrypt PDF Tool, you need to upload the encrypted PDF file
          you want to decrypt. Then, provide the correct password or decryption
          key. The tool will then remove the encryption, allowing you to access
          the content without any restrictions.
        </p>
      </div>
    ),
  },
  {
    id: 3,
    question: "Is Decrypting PDFs Legal?",
    answer: (
      <div className="">
        <p className="">
          Decrypting PDFs is legal if you have the right authorization to access
          the content. For example, if you are the owner of the document or have
          been given explicit permission to decrypt the file, it is legal to use
          Decrypt PDF Tools.
        </p>
      </div>
    ),
  },
  {
    id: 4,
    question: "Can Decrypted PDFs Be Re-encrypted?",
    answer: (
      <div className="">
        <p className="">
          Yes, decrypted PDFs can be re-encrypted if you want to apply security
          measures again. After decrypting a PDF, you can use encryption tools
          to protect the document by setting a new password or encryption
          settings.
        </p>
      </div>
    ),
  },
  {
    id: 5,
    question:
      "What Should I Do If I Encounter an Encrypted PDF Without a Password?",
    answer: (
      <div className="">
        <p className="">
          If you encounter an encrypted PDF without a password and do not have
          the authorization to access it, you should seek permission from the
          owner or the person who encrypted the file. Unauthorized attempts to
          decrypt a PDF may be against the law and violate privacy rights.
        </p>
      </div>
    ),
  },
];

function FileUpload() {
  const [file, setFile] = useState(null);
  const [password, setPassword] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const [signaturePopup, setSignaturePopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // const scrollToPreview = () => {
  //   const element = document.getElementById("password-field");
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const handleDrop = (e) => {
    e.preventDefault();
    if (!e.dataTransfer.files[0]) return;
    const file = e.dataTransfer.files[0];
    setFile(file);
    setError("");
    // scrollToPreview();
  };

  const handleFileChange = async (e) => {
    if (!e.target.files[0]) return;
    const file = e.target.files[0];
    setFile(file);
    setError("");
    // scrollToPreview();
  };

  const decryptPdf = async () => {
    setError("");
    if (!file) {
      setError("Please choose a file");
      return;
    }

    if (file.name.split(".").pop() !== "pdf") {
      setError("Please choose a pdf file");
      return;
    }

    if (!password || password === "") {
      setError("Please enter password");
      return;
    }

    if (file.size > 30000000) {
      setError("File Size is too large(>30MB)");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("password", password);
    try {
      setDownloading(true);
      const response = await axios.post(
        `${BASE_URL_POST}decryptPdf`,
        formData,
        {
          responseType: "blob",
        },
      );
      // console.log(response)
      downloadFile(response.data);
    } catch (error) {
      setDownloading(false);
      if (error.response.data.type === "text/html") {
        const blobReader = new FileReader();
        blobReader.addEventListener("loadend", () => {
          setError(blobReader.result);
        });
        blobReader.readAsText(error.response.data);
        return;
      }
      setError(error.response.data);
    }
  };

  const downloadFile = (blob) => {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "decrypted.pdf";
    link.click();
    setDownloading(false);
    setSignaturePopup(true);
  };

  return (
    <>
      <div className="w-full mt-20 sm:mt-24">
        <Head>
          <meta charSet="utf-8" />
          <title>Decrypt PDF Tool - BoloForms</title>
          <meta
            name="description"
            content="Remove encryption from your PDF files. Decrypt PDF Tool allows you to access protected content by providing the correct password or decryption key."
          />
          <meta
            name="keywords"
            content="decrypt pdf, remove pdf encryption, PDF decryption, access protected pdf, PDF security, decrypt PDF files, PDF encryption removal, PDF decryption tool, decrypt secured PDF, decrypt pdf boloforms, decrypt pdf online, decrypt pdf tool, decrypt pdf free, decrypt pdf file, decrypt pdf online free, decrypt pdf file online, decrypt pdf password, decrypt pdf file online free, decrypt pdf without password, decrypt pdf without password online, decrypt pdf without password free, decrypt pdf without password online free, decrypt pdf without password mac, decrypt pdf without password linux, decrypt pdf without password windows, decrypt pdf without password ubuntu"
          />
          <meta name="author" content="BoloForms" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <link
            rel="canonical"
            href="https://www.bolosign.com/signature/pdf-tools/decrypt-pdf"
          />
          <meta property="og:title" content="Decrypt PDF Tool - BoloForms" />
          <meta
            property="og:description"
            content="Remove encryption from your PDF files. Decrypt PDF Tool allows you to access protected content by providing the correct password or decryption key."
          />
          <meta
            property="og:url"
            content="https://www.bolosign.com/signature/pdf-tools/decrypt-pdf"
          />
          <meta property="og:site_name" content="BoloForms" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content="BoloForms" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en_US" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@BoloForms" />
          <meta name="twitter:creator" content="@BoloForms" />
          <meta name="twitter:title" content="Decrypt PDF Tool - BoloForms" />
          <meta
            name="twitter:description"
            content="Remove encryption from your PDF files. Decrypt PDF Tool allows you to access protected content by providing the correct password or decryption key."
          />
          <link
            rel="canonical"
            href="https://www.bolosign.com/signature/pdf-tools/decrypt-pdf"
          />
        </Head>

        <div className="">
          <div className="max-w-[1280px] mx-auto px-2 md:px-10 py-10 rounded-xl relative flex flex-col gap-20">
            <div className="text-violet-500 text-center">
              <h1 className="text-3xl md:text-6xl text-gray-800">
                Decrypt PDF Tool
              </h1>
              <p className="text-lg md:text-2xl mt-4 text-gray-600">
                Decrypt your PDF files with our free online Decrypt PDF Tool.
              </p>
            </div>
            <div
              className="extraOutline p-4 bg-white bg-whtie mx-auto rounded-lg w-full md:w-[600px]"
              onDragEnter={(e) => e.preventDefault()}
              onDragOver={(e) => e.preventDefault()}
              onDragLeave={(e) => e.preventDefault()}
              onDrop={handleDrop}
            >
              <div className="file_upload px-2 md:px-20 py-5 md:py-14 relative border-4 border-dotted border-gray-300 rounded-lg">
                <FaFileUpload className="text-gray-400 w-20 md:w-32 mx-auto mb-6 md:mb-10 text-[80px] md:text-[120px]" />
                <div className="input_field flex flex-col w-full mx-auto text-center">
                  <label>
                    <input
                      onChange={handleFileChange}
                      className="text-sm cursor-pointer w-36 hidden"
                      type="file"
                      accept=".pdf"
                    />
                    <div className="text bg-violet-600 text-white text-xl border border-gray-300 rounded-xl font-semibold cursor-pointer py-3 md:py-4 hover:bg-indigo-500">
                      Upload PDF File
                    </div>
                  </label>

                  {/* <div className="title text-gray-500 uppercase text-lg md:text-xl">
                    or drop file here 
                  </div> */}
                  <p className="text-gray-600 text-md">
                    {`Upload Your PDF File Here (Max Size: 30MB)`}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {file && (
            <div id="password-field" className="password-field">
              <div className="w-fit mx-auto flex justify-center mb-1 relative">
                <input
                  className="w-full md:w-[400px] outline-none border-2 border-gray-300 rounded-lg px-4 py-2 text-xl"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name=""
                  id=""
                />
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-violet-500 text-3xl cursor-pointer">
                  {showPassword ? (
                    <AiFillEyeInvisible
                      onClick={() => setShowPassword(false)}
                    />
                  ) : (
                    <AiFillEye onClick={() => setShowPassword(true)} />
                  )}
                </div>
              </div>
              {error && (
                <p className="text-red-500 text-center text-xl">{error}</p>
              )}
              <div className="w-full mt-4">
                <button
                  onClick={decryptPdf}
                  className="bg-violet-600 mx-auto w-[200px] px-2 py-2 text-lg rounded-lg font-semibold text-white flex items-center justify-center gap-4 hover:bg-violet-400"
                >
                  {downloading ? (
                    <div
                      className={`flex items-center text-white space-x-2 ${styles.loader}`}
                    >
                      <div className="">Decrypting</div>
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                    </div>
                  ) : (
                    <>
                      Decrypt PDF <FaKey />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
          {signaturePopup && (
            <SignaturePopup
              onPopupClose={() => setSignaturePopup(false)}
              source="DECRYPT_PDF"
            />
          )}

          <div className="mt-28">
            <div className="mb-20">
              <PdfToolsLinks />
            </div>
            <Blog heading="Decrypt PDF Tool FAQs" BlogData={BlogData} />
          </div>
        </div>
      </div>
    </>
  );
}

export default FileUpload;
